import React from "react";
import PropTypes from "prop-types";

import { Button } from "components/Button";
import Icon from "components/Icon";
import Loader, { InlineLoader } from "components/Loader";
import Text from "components/Text";
import { useAnswerContext } from "contexts/answerContext";
import useDownload from "hooks/useDownload";
import {
  useDownloadApplicationPDF,
  useDownloadIssuedApplicationPDF,
  useRequirementApplication,
} from "queries/requirementApplications";
import { isIssued } from "reducers/requirementApplications";

import styles from "./Download.scss";

const DownloadLink = ({
  mutation,
  children = <Text t="projects.application.download_application_pdf" />,
}) => {
  const { onDownload, isDownloadInProgress } = useDownload(mutation);
  return isDownloadInProgress ? (
    <InlineLoader />
  ) : (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <span className={styles.link} onClick={onDownload}>
      {children}
    </span>
  );
};

export const DownloadApplicationLink = ({ id, children }) => {
  const mutation = useDownloadApplicationPDF(id);
  return <DownloadLink mutation={mutation} children={children} />;
};

const DownloadButton = ({ mutation, children }) => {
  const { onDownload, isDownloadInProgress } = useDownload(mutation);
  if (isDownloadInProgress) {
    return <Loader />;
  }
  return (
    <Button
      data-download-application-button
      onClick={onDownload}
      label={
        <>
          <Icon icon="download" />
          <span>{children}</span>
        </>
      }
    />
  );
};

const DownloadApplicationPDF = ({ id }) => {
  const mutation = useDownloadApplicationPDF(id);
  return (
    <DownloadButton mutation={mutation}>
      <Text t="projects.application.download_application_pdf" />
    </DownloadButton>
  );
};

const DownloadIssuedApplicationPDF = ({ id }) => {
  const mutation = useDownloadIssuedApplicationPDF(id);
  return (
    <DownloadButton mutation={mutation}>
      <Text t="projects.application.download_requirement_pdf" />
    </DownloadButton>
  );
};

const Download = ({ id, hideApplication }) => {
  const { record } = useAnswerContext();
  const { data: application } = useRequirementApplication(record.id, id);
  const issued = application && isIssued(application);
  return (
    <div className={styles.container}>
      <div className="action-container">
        {issued && <DownloadIssuedApplicationPDF id={id} />}
        {!hideApplication && <DownloadApplicationPDF id={id} />}
      </div>
    </div>
  );
};
Download.propTypes = {
  hideApplication: PropTypes.bool,
  id: PropTypes.number.isRequired,
};

export default Download;
